'use client';

import { getCookie } from 'cookies-next';
import { useState } from 'react';
import { useOrderNotificationSSE } from '@/api/use-order-notification';
import { OrderNotificationToast } from '@/components/order-notification-toast';

interface OrderNotification {
  order_code: string;
  store_name: string;
  order_status: string;
  total_payment: number;
  time: number;
}

export default function NotificationDemo() {
  const [currentNotification, setCurrentNotification] =
    useState<OrderNotification | null>(null);
  const token = (getCookie('ws_token') as string) || '';

  const { messages } = useOrderNotificationSSE({
    token: token,
    onMessage: (msg) => {
      console.log('📩 New order notification:', msg);
      setCurrentNotification(msg);
    },
  });

  const handleCloseNotification = () => {
    setCurrentNotification(null);
  };

  return (
    <>
      <OrderNotificationToast
        notification={currentNotification}
        onClose={handleCloseNotification}
      />
    </>
  );
}
